import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";


export default function Russia() {
  const Navigate = useNavigate()
  return (
    <div className="vbgy">
      <div className="dfhtu">
        <h2>MBBS in Georgia</h2>
      </div>
      <div className="wityu">
        <img src="https://www.medstudies.in/wp-content/uploads/2023/03/6e07261c-3bb1-442c-bc80-b2cd88b3809e.jpg"></img>

        <p>
          <strong>Georgia,</strong> a Country located in the Caucasus region of
          Eurasia is one of the loved countries of the entire region. The
          country is bounded by Turkey and Armenia to the south, Black Sea
          towards its west, Azerbaijan by the southeast and from Russia to the
          north. Covering an area of around 69700 square kilometers, the country
          has the population of around 3720400 as per 2016 estimates and has the
          density of around 53.5. The country has the capital city 'Tbilisi',
          which is also the largest city of the country and is located on the
          banks of River Mtkvari.The country is the member of the Council of
          Europe and has a rich culture and traditions. The official language of
          the country is Georgian and is considered one of the oldest languages
          of the world.
          <br />
          <br />
          <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
        </p>
      </div>

      {/* 00000000000000000000000000000000000000000000000000000 */}

      <div className="nffd">
        <img src="https://eduniabroad.com/wp-content/uploads/2023/01/MBBS-in-Georgia.jpg"></img>
        <div className="nhjip">
          <h3
            style={{
              backgroundColor: "#ff9818",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            A BRIEF LOOK AT MBBS In GEOGRIA
          </h3>
          <br />
          <br />
          <table className="ewrfd">
            <tr>
              <td>Capital</td>
              <td>Tbilisi</td>
            </tr>
            <tr>
              <td>Population</td>
              <td>37.1 Lakhs(2020)</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>Georgian</td>
            </tr>
            <tr>
              <td>Medium of Instruction</td>
              <td>English</td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Georgian Lari(1 Lari= 27.00 inr)</td>
            </tr>
            <tr>
              <td>International Airport</td>
              <td>Tbilisi</td>
            </tr>
            <tr>
              <td>Recognition</td>
              <td>NMC(MCI), WHO, ECFMG, FAIMER, WDOMS</td>
            </tr>
            <tr>
              <td>Course Duration</td>
              <td>6 Years(5 + 1 Year's internship)</td>
            </tr>
            <tr>
              <td>Average cost of stay (Fee included)</td>
              <td>25-35 lakhs(Approx)</td>
            </tr>
            <tr>
              <td>Intake</td>
              <td>Summer & Winter</td>
            </tr>
          </table>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
      <div className="cxdsf">
        <div className="ugvuids">
          <h2>UNIVERSITY OF GEORGIA</h2>
          <table
            className="table"
            data-aos="zoom-in-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <tr>
              <th className="th title2">UNIVERSITY NAME</th>
              <th className="th title2">TUTION FEE</th>
              <th className="th title2">ACCOMOTETION & FOOD(PER/MONTH)</th>
              <th className="th title2">OTC</th>
              <th className="th title2">TOTAL IN 1ST YEAR (WITHOUT HOSTEL)</th>
              <th className="th title2">INCENTIVE</th>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>1.</span>Alte University
              </td>
              <td className="td">5500$ </td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7500$</td>
              <td className="td">1000$</td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>2.</span> Akaki Tsereteli State University
              </td>
              <td className="td">4500$</td>
              <td className="td">250$</td>
              <td className="td">2000$</td>
              <td className="td">6500$</td>
              <td className="td">1000$</td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>3.</span> Batumi Shota Rustaveli State University
              </td>
              <td className="td">6200$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">8200$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>4.</span> BAU International University, Batumi
              </td>
              <td className="td">6000$</td>
              <td className="td">300$</td>
              <td className="td">2500$</td>
              <td className="td">8500$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>5.</span> Caucasus University
              </td>
              <td className="td">5000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7000$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>6.</span> Caucasus International University
              </td>
              <td className="td">5500$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7500$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>7.</span> David Tvildiani Medical University{" "}
              </td>
              <td className="td">8000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">12,700$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>8. </span> East European University
              </td>
              <td className="td">5000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7000$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>9. </span> European University
              </td>
              <td className="td">5000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7000</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>10. </span>Georgian National University SEU{" "}
              </td>
              <td className="td">5500$</td>
              <td className="td">250$</td>
              <td className="td">2000$</td>
              <td className="td">7500$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>11.</span>Geomedi Medical University{" "}
              </td>
              <td className="td">5500$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7500</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>12</span>Grigol Robakidze University{" "}
              </td>
              <td className="td">5000</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7000</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>13 </span>Georgian American University
              </td>
              <td className="td">6000</td>
              <td className="td">250$</td>
              <td className="td">3500$</td>
              <td className="td">9500$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>14. </span>lvane Javakhishvili Tbilisi State University{" "}
              </td>
              <td className="td">8000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">10,000$</td>
              <td className="td">700$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>15. </span>Ilia State University
              </td>
              <td className="td">5900$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">7900$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>16. </span>Kutaisi University{" "}
              </td>
              <td className="td">4000</td>
              <td className="td">250$</td>
              <td className="td">2000$</td>
              <td className="td">6000$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>17. </span>New Vision University
              </td>
              <td className="td">7000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">9000$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>18. </span>Petre Shotadze Tbilisi Medical Academy{" "}
              </td>
              <td className="td">7000</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">9000$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>19. </span>Tbilisi State Medical University
              </td>
              <td className="td">8000</td>
              <td className="td">300$</td>
              <td className="td">2500$</td>
              <td className="td">10,500$</td>
              <td className="td">1000$ </td>
            </tr>

            <tr>
              <td className="td dflex dflexMob">
                <span>20. </span>University Of Georgia
              </td>
              <td className="td">6000$</td>
              <td className="td">300$</td>
              <td className="td">2000$</td>
              <td className="td">8000$</td>
              <td className="td">1000$ </td>
            </tr>
          </table>
        </div>
      </div>
      <section className="ugvui">
        <ul>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Above Mentioned Tution Fee (hangable According to Their Academic
            Session).
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Admission Fee, Documentation & VISA Processing Included in Package.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Form 2nd to 6th year's Exam Matriculation Fee & VISA Extension will
            be Extra.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Flight Ticket Charge Excluded.
          </li>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <span>
              <b>Note:</b>
            </span>
            <br />
            In certain case students have to pay either partial or full amount
            of tuition fee to the university soon after receive letter, as per
            the University instruction
          </li>
        </ul>
      </section>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}

      <div className="gsfas">
        <h3>GEORGIAN NATIONAL UNIVERSITY SEU</h3>

        <div className="sdgdfghf">
          <img src="https://eduflair.com/images/23/Tbilisi-State-Medical-University.jpg"></img>
          <p>
            Georgian National University SEU is a private institution
            established in 2001 and located in Tbilisi, Georgia. Georgian
            National University SEU used to be known as Ilia Chancha­ vadze. The
            University developed rapidly in a few years and became the prime
            choice of national and international students to pursue the MBBS
            career.
            <br />
            <strong>ESTO. : 2001</strong>
            <br />
            <strong>University Type : Private</strong>
            <br />
            <strong>Medium : English</strong>
            <br />
            <strong>ESTO. : No. of Indian Students : 500+</strong>
            <br />
          </p>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000 */}

      <div className="packageForFirstYear">
        <table className="table fgjhfghfg" border="1">
          <h2 style={{ textAlign: "center", width: "100%" }}>
            PACKAGE FOR 1ST YEAR STUDENT
          </h2>
          <thead>
          <tr >
                            <td className="td">TUITION FEE</td>
                            <td className="td td2">IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE & MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT ETC</td>
                            <td className="td">TOTAL FEE</td>
                            <td className="td">INCENTIVE</td>
                        </tr>
                      
                        <tr> 
                            <td className="td">5500$</td>
                            <td className="td">2000$</td>
                            <td className="td">7500$</td>
                            <td className="td">1000$</td>
                        </tr>
          </thead>
        </table>
        <p className="para border">ACCOMODATION & FOOD FEE PER MONTH - 250 $ (COMPULSORY)</p>
        <p className="para border pb0">ADMISSION FEE, VISA INCLUDED & FLIGHT TICKET AS PER ACTUAL</p>
      </div>

      {/* 000000000000000000000000000000000000000000000000000000000000000 */}

      <div
        className="packageForSixYear"
        data-aos="zoom-out"
        data-aos-duration="1000"
        data-aos-easing="linear"
      >
        <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
        <table className="table">
        <tr>
                        <th className="th title2">Package</th>
                        <th className="th title2">2nd</th>
                        <th className="th title2">3rd</th>
                        <th className="th title2">4th</th>
                        <th className="th title2">5th</th>
                        <th className="th title2">6th</th>
                    </tr>
                    {/* <!-- 2 --> */}
                    <tr>
                        <td className="td">Exam Matriculation Fee & Documentation</td>
                        <td className="td">400$</td>
                        <td className="td">400$</td>
                        <td className="td">400$</td>
                        <td className="td">400$</td>
                        <td className="td">400$</td>
                    </tr>
                    
                    {/* <!-- 3 --> */}
                    <tr>
                        <td className="td ">VISA Extention</td>
                        <td className="td">150$</td>
                        <td className="td">150$</td>
                        <td className="td">150$</td>
                        <td className="td">150$</td>
                        <td className="td">150$</td>
                    </tr>
        </table>
      </div>

      <div className="mainSec">
        <ul>
        <li className="para"><span> IMPORTANT NOTE <b>:</b></span><br/><br/>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                       Georgian National University SEU provides excellent academic facilities at less price without hidden charges. <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">   
                      The medium of teaching is English and Georgian language. <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                      The university is fully recognised by NMC and WHO. <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                       The university provides accommodation facilities occupied with all amenities required for the living of the students. <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                       The advanced study curriculum of the university is designed according to international standards. <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                       The university comprises 97 assistant professors and 133 faculties guiding worldwide medical aspirants
                    </p>
                </li>
        </ul>
      </div>
    </div>
  );
}
